$shm_service_task_list $mol_page
	filter? \
	title \Задачи
	add_title \Добавить задачу
	add? null
	task_rows /$mol_view
	head /
		<= List_head $shm_list_head
			title <= title
			filter? <=> filter? \
			add? <=> add? null
			Close null
			Settings null
	body /
		<= Tasks $mol_list
			rows <= task_rows
	foot /
		<= Add_foot $mol_button_major
			title <= add_title
			click? <=> add? null
	Task_link* $mol_link
		arg <= task_arg* *
		uri_off <= task_uri* \
		title <= task_title* \
		current <= task_current* false
		event *
			^
			click? <=> task_open*? null
		attr *
			^
			shm_service_task_new <= task_is_new* false
	Empty $mol_view
		sub / \Задач нет
	task_arg* *
	task_uri* \
	task_title* \
	task_current* false
	task_open*? null
	task_is_new* false
